import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Carousel3d from 'vue-carousel-3d'
import 'animate.css'
import '@/common/css/bootstrap.min.css'
//图片懒加载
import VueLazyload from 'vue-lazyload'

//引入element-ui的全部组件
import ElementUI from 'element-ui'
//引入element-ui的css
import 'element-ui/lib/theme-chalk/index.css'

import toMail from '@/components/toMail/index.vue'
Vue.component('to-mail', toMail)
//使用elementUI
Vue.use(ElementUI)
Vue.use(VueLazyload, {
  preLoad: 1.3,  // 加载区域，图片在当前满屏1 再加上往下走的30%的位置的都加载出来
  error: require('@/components/img/error.gif'),  // 加载错误时显示图片
  loading: require('@/components/img/loading.gif'), // 加载中显示图片
  attempt: 3  // 下载图片错误时重连次数
})

// import 'modernizr';
Vue.config.productionTip = false
Vue.use(Carousel3d)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
